module.exports = __webpack_public_path__ + "static/media/live-white.5b447348.svg";